import State from 'interfaces/state/State';

export const format$ = (state: State) => state.trackInformation.format;
export const file_name$ = (state: State) => state.trackInformation.file_name;
